import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

import '../../css/DemoModal.css';

export default function DemoModal({ onClose }) {
  const { t } = useTranslation();

  return (
    <div
      className="demo-modal-overlay"
      onClick={onClose} // click outside closes
    >
      <div
        className="demo-modal"
        onClick={(e) => e.stopPropagation()} // prevent overlay close
      >
        {/* ❌ Close button */}
        <button
          className="demo-modal-close"
          onClick={onClose}
          aria-label={t("common.close")}
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>

        <h2>{t("demoModal.title")}</h2>
        <p>{t("demoModal.subtitle")}</p>
      </div>
    </div>
  );
}
